export default __webpack_public_path__ + "static/cards-84a124dfb155db42c7d869e65a55d074.png";